document.addEventListener("DOMContentLoaded", () => {
  if (!window.wesite) return;

  const productTitle = window.wesite.product.title;
  const requestBtn = document.querySelector("#we_request");
  const requestDialog = document.querySelector("#request_dialog");
  const requestModal = requestDialog.querySelector(".we-request-modal");
  const successMessage = requestDialog.querySelector(".success-meesage");
  const errorMessage = requestDialog.querySelector(".error-message");
  const form = requestDialog.querySelector("form");
  const postalCodeInput = form.querySelector("#postalcode")
  const postalCodeError = form.querySelector(".postal-code-error")
  const phoneInput = form.querySelector("#phone")
  const phoneError = form.querySelector(".phone-error")
  const anhaengerWrapper = requestDialog.querySelector(".configuration");
  const productDetailsPrice = form.querySelector(".we-product-info .price")
  const paymentOption = form.querySelector(".we-product-info .payment-option")
  const phonePrefix = form.querySelector("#phone_prefix")
  let anhaenger = null;
  const leasingMap = {
    "ueberweisung": "Überweisung",
    "leasing": "Leasing",
    "finanzierung": "Finanzierung",
    "business": "Business",
    "privat": "Privat",
  }

  if(!requestBtn) return;

  function main() {
    initListeners();
    // initFloatedForm()
    initPostalCodeValidation()
    initPhoneValidation()
  }

  function initListeners() {
    requestBtn.addEventListener("click", async () => {
      anhaenger = await getAnhaenger();
      const extraProduct = getExtraProduct();
      if(extraProduct){
        anhaenger.push(extraProduct);
      }
      if(anhaenger.length > 0){
        fillAnhaengerInput();
        anhaengerWrapper.classList.remove("we-hide");
      } else{
        anhaengerWrapper.classList.add("we-hide");
      }
      fillPrice()
      fillPaymentOption()
      requestDialog.show();

    });
  }

  function initPostalCodeValidation(){
    postalCodeInput.addEventListener("input",debounce(() => {
      if(postalCodeInput.value.length >= 5 && !isNaN(postalCodeInput.value)){
        postalCodeError.innerHTML = ""
      } else {
        postalCodeError.innerHTML = "Postleitzahl ungültig"
      }
    }, 750))
  }

  function initPhoneValidation(){
    phoneInput.addEventListener("input",debounce(() => {
      if(phoneInput.value.length >= 5 && !isNaN(phoneInput.value)){
        phoneError.innerHTML = ""
      } else {
        phoneError.innerHTML = "Telefonnummer ungültig"
      }
    }, 750))
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

    function fillPrice(){
      if(window.wesite.product.template.includes("anfrage")){
        productDetailsPrice.innerHTML = ""
      } else {
        productDetailsPrice.innerHTML = "Preis: " + convertNumberToPrice(window.wesite.prices.getFinalPrice()) + " €"
      }
    }

    function fillPaymentOption(){
      if(window.wesite.paymentOption){
        paymentOption.innerHTML = "Zahlungsart: " + leasingMap[window.wesite.paymentOption.category] + " " + leasingMap[window.wesite.paymentOption.select]
      }
    }

    function convertNumberToPrice(price){
      const numb = (parseFloat(price) / 100).toFixed(2).replace(".", ",");
      let parts = numb.split(",");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return parts.join(",");
    }

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      if(postalCodeError.innerHTML !== "") return;
      if(phoneError.innerHTML !== "") return;
      const formData = new FormData(form);
      const jsonObject = formDataToJson(formData);

      jsonObject["message"] = prependString(
        jsonObject["message"] || "",
        anhaenger
      );
      if(window.wesite.paymentOption){
        jsonObject["message"] = jsonObject["message"] + "\n" + "\n" + "Zahlungsart: " + leasingMap[window.wesite.paymentOption.category] + " " + leasingMap[window.wesite.paymentOption.select]
      }
      jsonObject["main_sku"] = getMainSku();
      jsonObject["attachment_skus"] = getAttachmentSkus(anhaenger);
      jsonObject["price"] = getFullPrice();
      requestModal.classList.add("loading");
      //http://127.0.0.1:5001/woermann-api/us-central1/productRequest
      //https://productrequest-3mqsmxvsla-uc.a.run.app
      fetch(
        "https://productrequest-3mqsmxvsla-uc.a.run.app",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(jsonObject),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            throw new Error("Error");
          }
          requestModal.classList.remove("loading");
          // form.classList.add("hide");
          // successMessage.classList.remove("hide");
          errorMessage.classList.add("hide");
        })
        .then(() => {
          delete jsonObject.privacy;
          const clientPayload = { 
            firstName: jsonObject.firstname,
            surname: jsonObject.lastname,
            eMail: jsonObject.email,
            phoneNo: jsonObject.phone,
            postCode: jsonObject.postalcode,
            companyName: jsonObject.company
          }
          fetch(
            "https://prod-21.germanywestcentral.logic.azure.com:443/workflows/118eb60457d94b8bb61468030a516fe6/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=PmkQbIQ4-v-87Q196Lxgb_PeOtPopkHDeF5EN9KIwmY",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(clientPayload),
            }
          )
        })
        .then(() => {
          window.location.href = '/pages/erfolgreich-abgesendet';
        })
        .catch((error) => {
          requestModal.classList.remove("loading");
          errorMessage.classList.remove("hide");
        });
    });

    document.addEventListener("floatedFormLoaded", () => {
      const floatedRequestBtn = document.querySelector(
        ".floated-form #we_request"
      );
      floatedRequestBtn.addEventListener("click", () => {
        requestDialog.show();
      });
    });

  function prependString(string, prepend) {
    const stringAttachment = prepend.length
      ? prepend.reduce((acc, item) => {
          return acc + item.property + ": " + item.title + "\n";
        }, "")
      : "";
    const finalString = productTitle + "\n" + stringAttachment + "\n" + string;
    return finalString;
  }

  function fillAnhaengerInput(){
    // const textarea = anhaengerInput.querySelector("textarea");
    
    // Set the value
    anhaengerWrapper.innerHTML = "Ausgewähltes Zubehör:" + anhaenger.map((item) => `<p>- ${item.title}</p>`).join("");
    // const length = anhaenger.length;
  }

  function formDataToJson(formData) {
    const jsonObject = {};
    formData.forEach((value, key) => {
      if(key == "phone_prefix" || key == "phone"){
        jsonObject["phone"] = (jsonObject["phone"] || "") + value;
      } else {
        jsonObject[key] = value;
      }
    });
    return jsonObject;
  }

  function getAnhaenger() {
    return new Promise((resolve, reject) => {
      if(Object.keys(window.wesite.appData.attachments.data).length === 0) resolve([])
      const customEvent = new CustomEvent("attachmentDataRequest");
      document.addEventListener(
        "attachmentDataResponse",
        (event) => {
          resolve(event.detail);
        },
        { once: true }
      );
      document.dispatchEvent(customEvent);
    });
  }

  function getExtraProduct(){
    const customNode = document.querySelector('input.we-custom-node[name="items[1][id]"]');
    if(!customNode) return null;
    const data = {}
    const title = customNode.getAttribute("data-title");
    const property = title.split(" ")[0];
    data.property = property;
    data.title = title;
    data.id = customNode.value;
    return data;
  }

  function getMainSku() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('variant')) {
      const variantId = urlParams.get('variant');
      const findVariant = window.wesite.product.variants.find(variant => String(variant.id) === variantId);
      if(!findVariant) throw new Error('Sku Variant not found');
      return findVariant.sku;
    } else {
        return window.wesite.product.selected_or_first_available_variant.sku
    }
  }


  function getAttachmentSkus(anhaenger) {
    const urlParams = new URLSearchParams(window.location.search);
    let currentId = null
    if (urlParams.has('variant')) {
      currentId = urlParams.get('variant');
    } else {
      currentId = window.wesite.product.selected_or_first_available_variant.id
    }
    const attachments = window.wesite.appData.attachments.data[currentId]
    if(!attachments) return []
    const selectedAttachments = attachments.filter((attachment) => {
      return anhaenger.some((item) => item.title === attachment.data.title);
    });
    return selectedAttachments.map((attachment) => attachment.data.variants[0].sku);
  }

  function getFullPrice() {
    const fullPrice = document.querySelector("#full_price");
    if(!fullPrice){
      const fullPrice = document.querySelector(".price-item.price-item--regular")
      return fullPrice.innerHTML.trim();
    }
    return fullPrice.innerHTML.trim();
  }

  function initFloatedForm(){
    document.addEventListener("floatedFormLoaded", () => {
      const floatedForm = document.querySelector(".floated-form");
      if (!floatedForm) return;
      
      const requestBtn = floatedForm.querySelector("#we_request");
      if (!requestBtn) return;
      
      requestBtn.addEventListener("click", async () => {
        anhaenger = await getAnhaenger();
        const extraProduct = getExtraProduct();
        if(extraProduct){
          anhaenger.push(extraProduct);
        }
        if (anhaenger.length > 0) {
          fillAnhaengerInput();
          anhaengerWrapper.classList.remove("we-hide");
        } else {
          anhaengerWrapper.classList.add("we-hide");
        }
        fillPrice()
        fillPaymentOption()
        requestDialog.show();
      });
    });
  }

  main();
});
